export default {
    default: {
        /* eslint-disable global-require */
        '@spp/ui-article-list': require('@spp/ui-article-list/styles/ArticleList.scss'),
        '@spp/ui-author-header': require('@spp/ui-author-header/styles/AuthorHeader.scss'),
        '@spp/ui-blockquote': require('@spp/ui-blockquote/styles/Blockquote.scss'),
        '@spp/ui-break': require('@spp/ui-break/styles/Break.scss'),
        '@spp/ui-byline': require('@spp/ui-byline/styles/Byline.scss'),
        '@spp/ui-core-comments': require('@spp/ui-core-comments/styles/CoreComments.scss'),
        '@spp/ui-embed-content': require('@spp/ui-embed-content/styles/EmbedContent.scss'),
        '@spp/ui-factbox': require('@spp/ui-factbox/styles/Factbox.scss'),
        '@spp/ui-factbox:text': require('@spp/ui-text/styles/Text_Factbox.scss'),
        '@spp/ui-factbox:blockquote': require('@spp/ui-blockquote/styles/Blockquote_Factbox.scss'),
        '@spp/ui-factbox:lead': require('@spp/ui-lead-text/styles/LeadText_Factbox.scss'),
        '@spp/ui-factbox:subheading': require('@spp/ui-subheading/styles/Subheading_Factbox.scss'),
        '@spp/ui-factbox:subtitle': require('@spp/ui-subtitle/styles/Subtitle_Factbox.scss'),
        '@spp/ui-factbox:headline': require('@spp/ui-headline/styles/Headline_Factbox.scss'),
        '@spp/ui-factbox:list': require('@spp/ui-list/styles/List.scss'),
        '@spp/ui-grade': require('@spp/ui-grade/styles/Grade.scss'),
        '@spp/ui-headline': require('@spp/ui-headline/styles/Headline.scss'),
        '@spp/ui-image': require('@spp/ui-image/styles/Image.scss'),
        '@spp/ui-label': require('@spp/ui-label/styles/Label.scss'),
        '@spp/ui-lead-text': require('@spp/ui-lead-text/styles/LeadText.scss'),
        '@spp/ui-list': require('@spp/ui-list/styles/List.scss'),
        '@spp/ui-map': require('@spp/ui-map/styles/Map.scss'),
        '@spp/ui-share': require('@spp/ui-share/styles/Share.scss'),
        '@spp/ui-subheading': require('@spp/ui-subheading/styles/Subheading.scss'),
        '@spp/ui-subtitle': require('@spp/ui-subtitle/styles/Subtitle.scss'),
        '@spp/ui-svg': require('@spp/ui-svg/styles/Svg.scss'),
        '@spp/ui-teaser-small': require('@spp/ui-teaser-small/styles/Teaser.scss'),
        '@spp/ui-text': require('@spp/ui-text/styles/Text.scss'),
        /* eslint-enable global-require */
    },
};



/** WEBPACK FOOTER **
 ** ./~/@spp/roc-package-hyperion/app/theme/whitelabel.js
 **/